import React from 'react'
import {Box} from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import {useHistory} from 'react-router-dom'
import AppDialog from 'src/components-new/feedback/AppDialog'

const ICON_COLOR = '#1D4ED8'

interface CategoryPreviewDialogProps {
  open: boolean
  onClose: () => void
  title: string
  path: string
  children: React.ReactNode
}

export default function CategoryPreviewDialog({
  open,
  onClose,
  title,
  path,
  children,
}: CategoryPreviewDialogProps) {
  const history = useHistory()

  const handleSeeAll = () => {
    history.push(path)
    onClose()
  }

  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title={title}
      maxWidth='xs'
      actions={
        <Box
          onClick={handleSeeAll}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            cursor: 'pointer',
            color: ICON_COLOR,
            fontSize: 14,
            fontWeight: 500,
            flexShrink: 0,
            borderRadius: 1,
            px: 0.5,
            '&:hover': {textDecoration: 'underline'},
          }}
        >
          Vedi tutti
          <ArrowForwardIcon sx={{fontSize: 16}} />
        </Box>
      }
    >
      {children}
    </AppDialog>
  )
}
